import './FlashMessages.scss';

import React, {
  useEffect,
  useState
} from 'react';

import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { SUPER_USER } from '../../../actionTypes/Users/UserActionType';

function BannerMessages({ msg, msgShow }) {
  const { userRole } = useSelector(
    (state) => state.AppSession.userDetails
  );

  const { pathname } = useLocation();
  const [showBanner, setShowBanner] = useState(false);
  const allowedPagesPath = userRole === SUPER_USER ? ['/users'] : ['/', '/home'];

  useEffect(() => {
    setShowBanner(msgShow && allowedPagesPath.includes(pathname));
  }, [pathname, msgShow]);

  return showBanner ? (
    <div className={`banner-message`}>
      <div tabIndex="-1" className={`bm-container`} role="alert">
        <span dangerouslySetInnerHTML={{ __html: msg }} />
      </div>
    </div>
  ) : null;
}

export default BannerMessages;
